// noinspection JSUnresolvedVariable,Eslint
if (!ENVIRONMENT || ['development', 'test'].indexOf(ENVIRONMENT)) {
    require('./navigation-sensors-and-connectors.json'); // eslint-disable-line global-require
}

/**
 * Response parser
 * @param {{data:Object|Array}} response - Response object
 * @returns {Array|Object}
 */
function responseDataExtractor(response) {
    return response.data;
}

/**
 * NavigationService class.
 */
export default class NavigationService {
    /** @ngInject */
    constructor($q, ViewsApi, CategoriesApi) {
        this.$q = $q;
        this.ViewsApi = ViewsApi;
        this.CategoriesApi = CategoriesApi;
    }

    /**
     * Get Sensors and Connectors navigation data
     * @returns {promise}
     */
    getSensorsAndConnectors() {
        return this.$q.all({
            views: this.ViewsApi.getList({
                page_size: 100
            }),
            categories: this.CategoriesApi.getList({
                page_size: 100
            })
        }).then(({ views, categories }) => {
            const objects = [];
            const viewsArr = views.views || [];
            const categoriesArr = categories.categories || [];
            const categoriesMap = {};
            const usedCategories = [];

            categoriesArr.forEach((category) => {
                category.type = 'CATEGORY';
                categoriesMap[category.id] = category;
            });

            viewsArr.forEach((view) => {
                view.type = 'VIEW';
                if (view.category_id && categoriesMap[view.category_id]) {
                    const category = categoriesMap[view.category_id];
                    if (!category.children) {
                        category.children = [];
                    }
                    category.children.push(view);
                    if (category.children.length === 1) {
                        objects.push(category);
                    }
                    usedCategories.push(category.id);
                } else {
                    objects.push(view);
                }
            });

            Object.keys(categoriesMap)
                .filter(id => usedCategories.indexOf(id) < 0)
                .forEach((id) => {
                    objects.push(categoriesMap[id]);
                });

            return { objects };
        });

        // return this.$http.get(this.config.sensorsAndConnectorsUrl).then(responseDataExtractor);
    }

    /**
     * Update Sensors and Connectors navigation data
     * @param {Array<Object>} objects - Objects to be saved as Sensors and Connectors navigation data
     * @returns {promise}
     */
    updateSensorsAndConnectors(objects) {
        return this.$http.put(this.config.sensorsAndConnectorsUrl, { objects }).then(responseDataExtractor);
    }

}



// WEBPACK FOOTER //
// ./app/services/navigation/navigation.service.js